import {
    SPI,
    ActionType,
    BaseActionWidget,
    ReloadViewActionWidget,
    ViewType,
    Widget
} from '@kunlun/dependencies';
import customizeView from './customizeViewGoods.vue'

@SPI.ClassFactory(
    BaseActionWidget.Token({
        viewType:ViewType.Table,
        actionType: ActionType.Client,
        name: '$$internal_ReloadData',
        model: "deli.aries.trade.DeliSpecialApplyOrderDetail",
        widget: 'ClientAction',
    })
)
export class customizeViewGoods extends ReloadViewActionWidget {
    initialize(props: any) {
        super.initialize(props);
        this.setComponent(customizeView)
        return this;
    }

    //console.log(this.dataSource);//dataSource是表格数据 可以计算 settlementAmount
    @Widget.Reactive()
    protected get totalAmount() {
       let amount = 0
        const params: any = this.parentRootData
        if (params && params[0]?.expectedDeliveryDate) {
            amount=params[0]?.estimateAmount;
        }
      return amount;
    }

    @Widget.Reactive()
    protected get estimateAmount() {
        let sum = this.parentDataSource?.map(n => n.promotionAmount != undefined ? Number(n.promotionAmount) : 0).reduce((a: Number, c: Number) => {
            return   a.valueOf()  + c.valueOf()
        });
        return  Math.round((sum == undefined ? 0 : sum) * 100) / 100;
    }

    @Widget.Reactive()
    protected get promotionAmount() {
        let sum = this.parentDataSource?.map(n => n.settlementAmount != undefined ? Number(n.settlementAmount) : 0).reduce((a: Number, c: Number) => {
            return  a.valueOf()  + c.valueOf()
        });
        return Math.round((sum == undefined ? 0 : sum) * 100) / 100;
    }

}
